"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialEvents = exports.SOCIAL_POPUP = void 0;
var SOCIAL_POPUP;
(function (SOCIAL_POPUP) {
    SOCIAL_POPUP[SOCIAL_POPUP["ACCEPTED"] = 0] = "ACCEPTED";
    SOCIAL_POPUP[SOCIAL_POPUP["CANCELLED"] = 1] = "CANCELLED";
    SOCIAL_POPUP[SOCIAL_POPUP["REJECTED"] = 2] = "REJECTED";
    SOCIAL_POPUP[SOCIAL_POPUP["FAILED"] = 3] = "FAILED";
})(SOCIAL_POPUP = exports.SOCIAL_POPUP || (exports.SOCIAL_POPUP = {}));
var SocialEvents;
(function (SocialEvents) {
    SocialEvents["CONTEXT_CHANGE"] = "context_change";
    SocialEvents["SHOW_OVERLAY"] = "show_social_overlay";
    SocialEvents["HIDE_OVERLAY"] = "hide_social_overlay";
})(SocialEvents = exports.SocialEvents || (exports.SocialEvents = {}));
//# sourceMappingURL=ISocial.js.map